$(document).ready(function () {
    var page = $('body').attr('p') || '';
    if (page.indexOf('organizer_crm_') !== 0 && page !== 'organizer_partner_crm') return;

    if ($.fn.select2) {
        $('.select2').each(function () {
            var select = $(this);
            select.select2({
                theme: 'bootstrap4',
                width: '100%',
                placeholder: select.data('placeholder') || '',
                allowClear: !select.prop('required')
            });
        });
    }

    $(document).on('change', '#crm-contract-template', function () {
        var option = this.options[this.selectedIndex];
        var text = option ? option.getAttribute('data-text') || '' : '';
        var attachments = [];
        try {
            attachments = JSON.parse(option ? option.getAttribute('data-attachments') || '[]' : '[]');
        } catch (error) {
            attachments = [];
        }

        if (window.tinymce && tinymce.get('crm-contract-text')) {
            tinymce.get('crm-contract-text').setContent(text);
        } else {
            $('#crm-contract-text').val(text);
        }

        var preview = $('#crm-template-attachments');
        if (!option || !option.value) {
            preview.addClass('d-none').find('ul').empty();
            return;
        }

        var list = preview.removeClass('d-none').find('ul').empty();
        if (attachments.length) {
            attachments.forEach(function (attachment) {
                var item = $('<li>').text(attachment.name || '');
                if (attachment.description) {
                    $('<div>').addClass('text-muted small').text(attachment.description).appendTo(item);
                }
                item.appendTo(list);
            });
        } else {
            $('<li>').addClass('text-muted').text(translated($('.crm-contract-form'), 'template-no-attachments')).appendTo(list);
        }
    });

    $(document).on('click', '#crm-add-attachment', function () {
        var rows = $('#crm-attachment-rows');
        var row = rows.children('.crm-attachment-row').first().clone();
        row.find('input, textarea').val('');
        rows.append(row);
    });

    $(document).on('click', '.crm-remove-attachment', function () {
        var rows = $('#crm-attachment-rows');
        if (rows.children('.crm-attachment-row').length > 1) {
            $(this).closest('.crm-attachment-row').remove();
            return;
        }
        rows.find('input, textarea').val('');
    });

    $(document).on('submit', '.crm-contract-form', function (event) {
        var form = $(this);
        if (form.data('submitted')) {
            event.preventDefault();
            return;
        }
        form.data('submitted', true);
        form.find('button[type="submit"]').prop('disabled', true).text(translated(form, 'sending'));
    });

    function updateEmailRecipients() {
        var mode = $('input[name="recipient_mode"]:checked').val();
        $('.crm-recipient-mode-card').removeClass('is-active').has('input:checked').addClass('is-active');
        $('.crm-recipient-options').each(function () {
            var active = $(this).data('mode') === mode;
            $(this).toggleClass('d-none', !active).find('select').prop('required', active);
        });

        var summary = $('#crm-recipient-summary');
        if (!summary.length) return;
        var recipients = [];
        var context = '';
        if (mode === 'all') {
            try {
                recipients = JSON.parse(summary.attr('data-all-partners') || '[]');
            } catch (error) {
                recipients = [];
            }
        } else if (mode === 'categories') {
            var categoryNames = [];
            $('#crm-email-categories option:selected').each(function () {
                categoryNames.push($(this).attr('data-name') || '');
                try {
                    recipients = recipients.concat(JSON.parse($(this).attr('data-partners') || '[]'));
                } catch (error) {
                    // Ignore invalid preview metadata; the server still validates recipients.
                }
            });
            if (!categoryNames.length) {
                summary.find('p').text(translated(summary, 'choose-categories'));
                return;
            }
            context = interpolate(translated(summary, 'selected-categories'), {categories: categoryNames.join(', ')}) + ' ';
        } else {
            $('#crm-email-partners option:selected').each(function () {
                recipients.push({id: parseInt(this.value, 10), name: $(this).attr('data-name') || '', email: $(this).attr('data-email') || ''});
            });
            if (!recipients.length) {
                summary.find('p').text(translated(summary, 'choose-partners'));
                return;
            }
        }

        var unique = {};
        recipients.forEach(function (partner) {
            var key = partner.id || String(partner.email).toLowerCase();
            if (key) unique[key] = partner;
        });
        recipients = Object.keys(unique).map(function (key) { return unique[key]; });
        if (!recipients.length) {
            summary.find('p').text(context + translated(summary, 'no-active-partners'));
            return;
        }
        var visible = recipients.slice(0, 5).map(function (partner) {
            return partner.name + (partner.email ? ' <' + partner.email + '>' : '');
        });
        var more = recipients.length > visible.length
            ? ' ' + interpolate(translated(summary, 'more'), {count: recipients.length - visible.length})
            : '';
        var recipientText = translated(summary, recipients.length === 1 ? 'recipient-one' : 'recipient-many');
        summary.find('p').text(context + interpolate(recipientText, {count: recipients.length, list: visible.join(', '), more: more}));
    }

    $(document).on('change', 'input[name="recipient_mode"], #crm-email-categories, #crm-email-partners', updateEmailRecipients);
    updateEmailRecipients();

    if ($('.tinymce').length && typeof tinymce !== 'undefined') {
        var darkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
        var settings = {
            selector: '.tinymce',
            content_style: darkMode
                ? 'html,body{background:#323232!important;color:#eee!important;} .mce-content-body{font-size:14px;line-height:1.6;padding:16px;} a{color:#a8c9ff;}'
                : '.mce-content-body{font-size:14px;line-height:1.6;padding:16px;}',
            plugins: 'table,code,hr,link,searchreplace,visualblocks,fullscreen,lists',
            toolbar: 'formatselect | bold italic | link | alignleft aligncenter alignright | numlist bullist | removeformat',
            convert_urls: false,
            relative_urls: false,
            branding: false,
            content_css: '/public/static/' + $('body').data('vendor-css')
        };
        if (darkMode) settings.skin = 'oxide-dark';
        if ($('body').attr('lang') === 'no') settings.language = 'nb_NO';
        tinymce.init(settings);
    }
});
    function translated(element, name, fallback) {
        return element.attr('data-' + name) || fallback || '';
    }

    function interpolate(template, values) {
        Object.keys(values).forEach(function (key) {
            template = template.split('%' + key + '%').join(values[key]);
        });
        return template;
    }
